import { Component, computed, input, output } from '@angular/core';
import { JssNavItem } from '@core/jss-models';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NavLinkComponent } from '@core/navigation-ui/nav-link';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

@Component({
  selector: 'wl-navigation-mobile-item',
  standalone: true,
  templateUrl: './navigation-mobile-item.component.html',
  styleUrls: [
    './navigation-mobile-item.component.ed.scss',
    './navigation-mobile-item.component.essent.scss',
  ],
  imports: [FaIconComponent, NavLinkComponent, AutomationIdDirective],
})
export class NavigationMobileItemComponent {
  readonly navigationItem = input.required<JssNavItem>();

  readonly shouldShowDetails = computed(() => {
    const children = this.navigationItem().children;

    return (
      children &&
      children.length > 0 &&
      this.navigationItem().path?.length === 0
    );
  });

  navigate = output();
}
